import { IFileDownloadResponse } from '@common/interfaces/request'
import { Action } from 'redux'
import { put, takeEvery } from 'redux-saga/effects'
import { download } from '../../helpers/helpers'
import { EXPORT_REPORTS_FAILURE, EXPORT_REPORTS_SUCCESS } from './actions'

export function* exportQboReports() {
  yield takeEvery(EXPORT_REPORTS_SUCCESS, function* (action: IFileDownloadResponse & Action) {
    try {
      yield download(action.data, action.data.name)
    } catch (error: unknown) {
      yield put({ type: EXPORT_REPORTS_FAILURE, error })
    }
  })
}
